














import {Component, Prop, PropSync, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
  name: "DetailLading"
})
export default class extends mixins(CommonMixin) {
  @PropSync("visible", { type: Boolean, default: false }) syncVisible!: boolean;
}
